
<script>
  export let file
  import {beforeUpdate} from "svelte"
  let src = ""
  let myprops
  let prev_file = ""
  beforeUpdate(()=>{
    let changeKey = file.name+file.size+file.lastModified
    if(prev_file==changeKey) return
    prev_file = changeKey
    let reader  = new FileReader();
    reader.addEventListener("load",()=>{
      console.log("gen src")
      src = reader.result
    },false)
    reader.readAsDataURL(file)
  })
</script>
<img src={src} {...$$restProps} />
